import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ResetPassword } from '../../../shared/models/rest-password.model';

@Injectable()
export class PasswordRecoveryRepository {
  options = {};
  constructor(private http: HttpClient) {}

  recoverPassword(userName: string): Observable<any> {
    const path = environment.user.recoverPassword;

    return this.http.post(
      path,
      { username: userName },
      {
        observe: 'response',
        headers: this.options,
      },
    );
  }
  resetPassword(username: string, resetToken: string, passwords: ResetPassword): Observable<any> {
    const path = environment.user.resetPassword.replace('{username}', username).replace('{token}', resetToken);
    return this.http.post(path, passwords, {
      observe: 'response',
      headers: this.options,
    });
  }
  checkResetTokenValid(username: string, token: string): Observable<any> {
    const path = environment.user.checkResetPasswordToken.replace('{username}', username).replace('{token}', token);
    return this.http.get(path, {
      observe: 'response',
      headers: this.options,
    });
  }
}
